import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=bfa95db8&scoped=true&"
import script from "./ReportForm.vue?vue&type=script&lang=js&"
export * from "./ReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa95db8",
  null
  
)

export default component.exports